import * as styles from "./DatePickerValue.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { useDatePickerContext } from "./DatePicker.context";
import type { DatePickerValueProps } from "./DatePicker.types";
import type { CalendarDate } from "./dateMath";

export function DatePickerValue({
  placeholder = "--/--/----",
  className,
}: DatePickerValueProps): JSX.Element {
  const { selected, range, selectedRange, openEnd, openEnded, locale } =
    useDatePickerContext();

  const format = (date: CalendarDate) =>
    new Intl.DateTimeFormat(locale, { dateStyle: "medium" }).format(
      new Date(date.year, date.month, date.day),
    );

  const formatted = range
    ? null === selectedRange[0]
      ? null
      : [
          format(selectedRange[0]),
          openEnded
            ? openEnd?.label
            : selectedRange[1] && format(selectedRange[1]),
        ]
          .filter(Boolean)
          .join(" – ")
    : selected && format(selected);

  return (
    <span
      data-slot="date-picker-value"
      className={clsx(
        styles.value,
        !formatted && styles.placeholder,
        className,
      )}
    >
      {formatted || placeholder}
    </span>
  );
}
